"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SelectPrimitive = require("@radix-ui/react-select");
const select_content_1 = require("./select-content");
const select_item_1 = require("./select-item");
const select_label_1 = require("./select-label");
const select_separator_1 = require("./select-separator");
const select_trigger_1 = require("./select-trigger");
const Select = ({ children, ...props }) => ((0, jsx_runtime_1.jsx)(SelectPrimitive.Root, { ...props, onValueChange: (value) => {
        props.onChange?.({ target: { value } });
        props.onValueChange?.(value);
    }, children: children }));
exports.Select = Select;
exports.Select.Group = SelectPrimitive.SelectGroup;
exports.Select.Value = SelectPrimitive.SelectValue;
exports.Select.Trigger = select_trigger_1.SelectTrigger;
exports.Select.Content = select_content_1.SelectContent;
exports.Select.Label = select_label_1.SelectLabel;
exports.Select.Item = select_item_1.SelectItem;
exports.Select.Separator = select_separator_1.SelectSeparator;
